export default "__VITE_ASSET__igyV3jiJ__"